
import { Vue, Component, Watch } from 'vue-property-decorator';
import { getDetail } from '../api';
import { isWeiXin } from '@/common/ts/common';
import VoteButton from '../components/VoteButton.vue';
import { unionIdIsBind } from '@/api/api';
@Component({
  components: { VoteButton },
})
export default class Detail extends Vue {
  voteNum = '';
  voteName = '2022project/q1/2022manufacture';
  detailData: any = {};
  async mounted() {
    const data = {
      type: 2,
      unionId: window.localStorage.getItem('unionid'),
    };
    if (isWeiXin()) {
      const res: any = await unionIdIsBind(data);
      if (!res.data) {
        this.$router.push('/BindPhone');
      }
    }
  }
  get detail() {
    return this.$route.query;
  }
  async created() {
    const res = await getDetail(this.detail.id as string);
    this.detailData = res.data;
    this.voteNum = this.detailData.votes;
  }
  votSuccess(data: any) {
    this.voteNum = data;
  }
}
